import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {ApplicationState} from "../../../store";
import {IconComponent} from "../../reusable/simpleComponents";
import {TimelineState} from "../../../store/timeline/types";
import {setPlaybackmode} from "../../../store/timeline/actions";

const PauseUIComponent = () => {
    const { playbackMode, changeIconView } = useSelector<ApplicationState, TimelineState>(state => state.timeline);
    const dispatch = useDispatch();
    const active = playbackMode === 'pause';

    const handler = () => {
        !active && dispatch(setPlaybackmode('pause'));
    };

    return (
        <IconComponent classValue={active && changeIconView ? 'player pause active icon playback-icon' : 'player pause icon playback-icon'}
                       handler={handler}
                       title="Pause Video"
        />
    )
}

export default PauseUIComponent